var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Preact from 'preact';
import { Box } from '@mui/material';
export var Component = function (p) {
    return (Preact.h(Box, { position: "static", sx: __assign({ backgroundImage: "url(".concat(p.imageSrc, ")"), backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', display: 'flex', width: '100%' }, p.sx) }));
};
Component.displayName = 'Image';
